import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-u1188",
  "use": "icon-u1188-usage",
  "viewBox": "0 0 62 53",
  "content": "<symbol xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 62 53\" id=\"icon-u1188\">\r\n  <g transform=\"matrix(1 0 0 1 -319 -792 )\">\r\n    <path d=\"M 319 792  L 381 792  L 381 845  L 319 845  L 319 792  \" fill-rule=\"nonzero\" fill=\"#cccccc\" stroke=\"none\" />\r\n    <path d=\"M 323 796  L 377 796  L 377 841  L 323 841  L 323 796  \" fill-rule=\"nonzero\" fill=\"#ffffff\" stroke=\"none\" />\r\n    <path d=\"M 355.215 807.9  C 352.989 807.9  351.24 806.151  351.24 803.925  C 351.24 801.699  352.989 799.95  355.215 799.95  C 357.441 799.95  359.19 801.699  359.19 803.925  C 359.19 806.151  357.441 807.9  355.215 807.9  \" fill-rule=\"nonzero\" fill=\"#cccccc\" stroke=\"none\" />\r\n    <path d=\"M 325 840  L 325 816.9  L 337.75 806.4  L 355.6 818.458064516129  L 365.8 812.7  L 376 818.458064516129  L 376 840  L 325 840  \" fill-rule=\"nonzero\" fill=\"#169bd5\" stroke=\"none\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/u1188.svg
// module id = Y8NY
// module chunks = 115